import {API_URLS} from '@/const';
import {http} from '@/helper';

export const operationApi = {
  getOperationBannersLogout(query) {
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {query});
  },
  getOperationBannersLogin(query) {
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGIN, {query});
  },
  getDialogDataList(query) {
    return http.get(API_URLS.INNER_DIALOG, {query});
  },
  getTestDialogDataList(query) {
    return http.get(API_URLS.INNER_DIALOG_TESTING, {query});
  },
};
